import { COHORT_TENURE, NRR_COHORT, type CohortRow } from "./exampleData";
import MetricChartFrame from "./MetricChartFrame";

interface CohortHeatmapProps {
  caption: string;
  cohorts: CohortRow[];
  metricLabel: string;
}

/**
 * Cohort retention heatmap — rows are acquisition cohorts, columns are tenure
 * months, cells are shaded by retention %. Younger cohorts have fewer cells, so
 * the grid is triangular, exactly like the app's cohort view.
 */
const CohortHeatmap = ({ caption, cohorts, metricLabel }: CohortHeatmapProps) => (
  <MetricChartFrame caption={caption} active="1Y" raw hideControls>
    <div className="overflow-x-auto">
      <table className="w-full border-separate border-spacing-1 text-xs">
        <thead>
          <tr>
            <th className="px-2 py-1 text-left font-medium text-muted-foreground">{metricLabel}</th>
            {COHORT_TENURE.map((t) => (
              <th key={t} className="px-2 py-1 text-center font-medium text-muted-foreground">
                {t}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {cohorts.map((row) => (
            <tr key={row.label}>
              <td className="px-2 py-1 font-medium text-muted-foreground">{row.label}</td>
              {COHORT_TENURE.map((_, i) => {
                const v = row.values[i];
                return v == null ? (
                  <td key={i} />
                ) : (
                  <td
                    key={i}
                    className={`rounded px-2 py-1.5 text-center tabular-nums ${
                      v < 100 ? "bg-rose-100 text-rose-900" : "bg-sky-100 text-gray-800"
                    }`}
                  >
                    {v}%
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </MetricChartFrame>
);

export const NrrCohortChart = () => (
  <CohortHeatmap
    caption="Each row is a signup cohort, each column a month of tenure. Cells start at 100%, dip below as early churn bites, then recover above it once expansion takes over — read across a row to watch one cohort mature, down a column to compare cohorts at the same age."
    cohorts={NRR_COHORT}
    metricLabel="Cohort"
  />
);
